import { Box, Typography, Grid } from '@mui/material';
import React from 'react';
import { dataConstants } from "../../../constants";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { colors, radii, shadows } from "../../../utils/designTokens";

const { PLAN_COMPARISON } = dataConstants || {};

const PremiumFeatures = () => {
  return (
    <Box
      id="features"
      sx={{
        scrollMarginTop: '80px',
        py: { xs: 6, md: 8 },
        borderTop: `1px solid ${colors.neutral[200]}`,
      }}
    >
      {/* Section heading */}
      <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 5 } }}>
        <Typography
          variant="overline"
          component="div"
          sx={{
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '0.1em',
            color: colors.accent.main,
            mb: 1.5,
          }}
        >
          WHAT YOU GET
        </Typography>
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '1.4rem', md: '1.75rem' },
            color: colors.neutral[900],
            mb: 1.5,
          }}
        >
          Premium Features
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: colors.neutral[500], maxWidth: 480, mx: 'auto' }}
        >
          Everything you need for smarter investing decisions, in one place.
        </Typography>
      </Box>

      {/* Feature grid */}
      <Grid container spacing={2.5}>
        {PLAN_COMPARISON.map((row, idx) => (
          <Grid key={idx} size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2.5,
                borderRadius: `${radii.md}px`,
                border: `1px solid ${colors.neutral[100]}`,
                bgcolor: colors.neutral[25],
                height: '100%',
                transition: 'border-color 200ms ease, box-shadow 200ms ease',
                '&:hover': {
                  borderColor: colors.neutral[200],
                  boxShadow: shadows.xs,
                },
              }}
            >
              <CheckRoundedIcon sx={{ fontSize: '1.25rem', color: colors.success.main, mt: 0.25, flexShrink: 0 }} />
              <Box>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{
                    fontWeight: 600,
                    color: colors.neutral[800],
                    mb: 0.5,
                    '& a': { color: colors.accent.main, textDecoration: 'none', fontWeight: 600 },
                    '& a:hover': { textDecoration: 'underline' },
                  }}
                  dangerouslySetInnerHTML={{ __html: row.feature_name }}
                />
                {row.feature_desc && (
                  <Typography
                    variant="caption"
                    component="div"
                    sx={{
                      color: colors.neutral[500],
                      lineHeight: 1.55,
                      '& a': { color: colors.accent.main, textDecoration: 'none' },
                      '& a:hover': { textDecoration: 'underline' },
                    }}
                    dangerouslySetInnerHTML={{ __html: row.feature_desc }}
                  />
                )}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PremiumFeatures;
